import dayjs from "dayjs";

export const getPaymentDue = (
  connection: {
    paymentDueCalculateFrom:
      | "endOfMonth"
      | "endOfFollowingMonth"
      | "invoiceIssueDate"
      | null;
    paymentDue: number | null;
  },
  startDate?: Date | null,
) => {
  switch (connection?.paymentDueCalculateFrom) {
    case "endOfMonth":
      return dayjs(startDate ?? new Date())
        .endOf("month")
        .add(connection.paymentDue ?? 0, "day")
        .startOf("day")
        .toDate();
    case "endOfFollowingMonth": {
      const currentMonth = dayjs().get("month") + 1;
      return dayjs(startDate ?? new Date())
        .set("month", currentMonth)
        .endOf("month")
        .add(connection.paymentDue ?? 0, "day")
        .startOf("day")
        .toDate();
    }
    default:
      return dayjs(startDate ?? new Date())
        .add(connection.paymentDue ?? 0, "day")
        .startOf("day")
        .toDate();
  }
};
